<div class="consolidado-section">
  <div class="consolidado-header">
    <h2>{{ 'Abierto por PDV — Batch por Mês' | translate }}</h2>

    <div class="consolidado-filtros">
      <div class="filtro">
        <label for="cboPdvPais">{{ 'País' | translate }}</label>
        <select id="cboPdvPais" [(ngModel)]="filtro.countryCode" (change)="onPaisChange()">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let p of listPaises; trackBy: trackByCountryCode" [value]="p.countryCode">{{ p.name }}</option>
        </select>
      </div>

      <div class="filtro">
        <label for="cboPdvAno">{{ 'Ano' | translate }}</label>
        <select id="cboPdvAno" [(ngModel)]="filtro.ano">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let a of listAnos; trackBy: trackByIndex" [value]="a">{{ a }}</option>
        </select>
      </div>

      <div class="filtro">
        <label for="cboPdvMes">{{ 'Mês' | translate }}</label>
        <select id="cboPdvMes" [(ngModel)]="filtro.mes">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let m of listMeses; trackBy: trackByIndex" [value]="m.value">{{ m.label | translate }}</option>
        </select>
      </div>

      <div class="filtro">
        <label for="txtCdgCiu">{{ 'Cidade (opt.)' | translate }}</label>
        <input id="txtCdgCiu" type="text" [(ngModel)]="filtro.cdgCiu"
               [placeholder]="'Cód. Cidade' | translate" />
      </div>

      <div class="filtro">
        <label for="txtCdgFcia">{{ 'Farmácia (opt.)' | translate }}</label>
        <input id="txtCdgFcia" type="text" [(ngModel)]="filtro.cdgFcia"
               [placeholder]="'Cód. Farmácia' | translate" />
      </div>

      <div class="filtro">
        <label for="cboPdvGrupo">{{ 'Grupo (opt.)' | translate }}</label>
        <select id="cboPdvGrupo" [(ngModel)]="filtro.groupId">
          <option value="">{{ 'Todos' | translate }}</option>
          <option *ngFor="let g of listGrupos; trackBy: trackByGroupId" [value]="g.id">{{ g.name }}</option>
        </select>
      </div>

      <button class="btn-buscar" (click)="buscar()"
        [disabled]="!filtro.countryCode || !filtro.ano || !filtro.mes || isLoading">
        <span *ngIf="!isLoading">{{ 'Consultar' | translate }}</span>
        <span *ngIf="isLoading">{{ 'Carregando...' | translate }}</span>
      </button>

      <button class="btn-limpar" (click)="limpar()" [disabled]="isLoading">
        {{ 'Limpar' | translate }}
      </button>

      <button class="btn-exportar" (click)="exportarCsv()"
        *ngIf="dados.length > 0" [disabled]="isLoading">
        {{ '↓ Exportar CSV' | translate }}
      </button>
    </div>
  </div>

  <!-- Tabela -->
  <div class="consolidado-table-wrap">
    <table class="consolidado-table mat-elevation-z2">

      <thead>
        <tr class="col-header-row">
          <th>{{ 'FechaProceso' | translate }}</th>
          <th>{{ 'CdgCiu' | translate }}</th>
          <th>{{ 'CdgFcia' | translate }}</th>
          <th>{{ 'Desc Fcia' | translate }}</th>
          <th>{{ 'Total Imgs' | translate }}</th>
          <th>{{ 'No son Rxs' | translate }}</th>
          <th>{{ 'En Cola' | translate }}</th>
          <th>{{ 'Procesadas' | translate }}</th>
          <th>{{ 'Validas APPI' | translate }}</th>
          <th>{{ 'Validas DE' | translate }}</th>
          <th>{{ 'Pendientes Rev.' | translate }}</th>
          <th>{{ '% Validas APPI' | translate }}</th>
          <th>{{ '% Validas DE' | translate }}</th>
          <th>{{ '% Pend. Rev.' | translate }}</th>
          <th *ngIf="filtroGrupoAplicado">{{ 'Grupo' | translate }}</th>
        </tr>
      </thead>

      <!-- DADOS -->
      <tbody>
        <tr *ngIf="isLoading" class="row-empty">
          <td [attr.colspan]="filtroGrupoAplicado ? 15 : 14" class="empty-msg loading-msg">{{ 'Carregando...' | translate }}</td>
        </tr>
        <tr *ngIf="!isLoading && dados.length === 0" class="row-empty">
          <td [attr.colspan]="filtroGrupoAplicado ? 15 : 14" class="empty-msg">
            <span *ngIf="semDados">{{ 'Nenhum dado encontrado para os filtros selecionados.' | translate }}</span>
            <span *ngIf="!semDados">{{ 'Selecione os filtros e clique em Consultar.' | translate }}</span>
          </td>
        </tr>
        <tr *ngFor="let row of dados; let i = index; trackBy: trackByRow"
            [class.row-alt]="i % 2 !== 0" [hidden]="isLoading">
          <td>{{ row.fechaProceso }}</td>
          <td>{{ row.cdgCiu }}</td>
          <td>{{ row.cdgFcia }}</td>
          <td>{{ row.descFcia }}</td>
          <td class="num">{{ row.totalImagenes | number }}</td>
          <td class="num">{{ row.noSonRxs | number }}</td>
          <td class="num">{{ row.imagenesEnCola | number }}</td>
          <td class="num">{{ row.imagenesProcesadas | number }}</td>
          <td class="num grp-appi-col">{{ row.validasAPPI | number }}</td>
          <td class="num grp-de-col">{{ row.validasDE | number }}</td>
          <td class="num grp-pend-col">{{ row.pendientesRevision | number }}</td>
          <td class="num pct grp-appi-col">{{ (row.imagenesProcesadas > 0 ? (row.validasAPPI / row.imagenesProcesadas * 100) : 0) | number:'1.1-1' }}%</td>
          <td class="num pct grp-de-col">{{ (row.imagenesProcesadas > 0 ? (row.validasDE / row.imagenesProcesadas * 100) : 0) | number:'1.1-1' }}%</td>
          <td class="num pct grp-pend-col">{{ (row.imagenesProcesadas > 0 ? (row.pendientesRevision / row.imagenesProcesadas * 100) : 0) | number:'1.1-1' }}%</td>
          <td *ngIf="filtroGrupoAplicado">{{ row.grupo }}</td>
        </tr>
      </tbody>

      <!-- TOTAIS -->
      <tfoot *ngIf="dados.length > 0 && !isLoading">
        <tr class="total-row">
          <td colspan="4">{{ 'Total' | translate }}</td>
          <td class="num">{{ totais.totalImagenes | number }}</td>
          <td class="num">{{ totais.noSonRxs | number }}</td>
          <td class="num">{{ totais.imagenesEnCola | number }}</td>
          <td class="num">{{ totais.imagenesProcesadas | number }}</td>
          <td class="num">{{ totais.validasAPPI | number }}</td>
          <td class="num">{{ totais.validasDE | number }}</td>
          <td class="num">{{ totais.pendientesRevision | number }}</td>
          <td class="num pct">{{ totais.porcValidasAPPI | number:'1.1-1' }}%</td>
          <td class="num pct">{{ totais.porcValidasDE | number:'1.1-1' }}%</td>
          <td class="num pct">{{ totais.porcPendientes | number:'1.1-1' }}%</td>
          <td *ngIf="filtroGrupoAplicado"></td>
        </tr>
      </tfoot>

    </table>
  </div>
</div>
